import React from 'react';
import { KIND as POSITION_KIND, WORK_MODE } from 'components/collab/positions/positionLabels';
import {
  Typography,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Tooltip
} from '@mui/material';

const FilterPanel = ({ 
  expanded, 
  onExpandChange, 
  activeTab,
  inputValues,
  onInputChange,
  onSearchClick,
  onClearFilters,
  viewMode,
  onViewModeChange
}) => {
  return (
    <Box 
      sx={{ 
        mb: 2, 
        p: 2, 
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        bgcolor: 'background.paper'
      }}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Typography 
          variant="subtitle1" 
          sx={{ 
            minWidth: 'fit-content',
            fontWeight: 600,
            color: 'text.primary'
          }}
        >
          Search By
        </Typography>
        
        {activeTab === 0 ? (
          <Box display="flex" gap={2} flex={1}>
            <TextField
              label="Affiliation"
              value={inputValues.affiliation || ''}
              onChange={(e) => onInputChange('affiliation', e.target.value)}
              placeholder="Filter by affiliation..."
              size="small"
              fullWidth
            />
            <TextField
              label="Skills & Expertise"
              value={inputValues.keywords || ''}
              onChange={(e) => onInputChange('keywords', e.target.value)}
              placeholder="Filter by skills, expertise, or research interests..."
              size="small"
              fullWidth
            />
            <TextField
              label="Country"
              value={inputValues.country || ''}
              onChange={(e) => onInputChange('country', e.target.value)}
              placeholder="Filter by country..."
              size="small"
              fullWidth
            />
          </Box>
        ) : activeTab === 3 ? (
          <Box display="flex" gap={2} flex={1} alignItems="center">
            <FormControl size="small" fullWidth>
              <InputLabel>Type</InputLabel>
              <Select value={inputValues.positionKind || ''} label="Type" onChange={(e) => onInputChange('positionKind', e.target.value)}>
                <MenuItem value="">All types</MenuItem>
                {Object.entries(POSITION_KIND).map(([v, l]) => <MenuItem key={v} value={v}>{l}</MenuItem>)}
              </Select>
            </FormControl>
            <FormControl size="small" fullWidth>
              <InputLabel>Where</InputLabel>
              <Select value={inputValues.workMode || ''} label="Where" onChange={(e) => onInputChange('workMode', e.target.value)}>
                <MenuItem value="">Anywhere</MenuItem>
                {Object.entries(WORK_MODE).map(([v, l]) => <MenuItem key={v} value={v}>{l}</MenuItem>)}
              </Select>
            </FormControl>
            <TextField label="Country or city" value={inputValues.country || ''} onChange={(e) => onInputChange('country', e.target.value)}
              placeholder="e.g. Türkiye" size="small" fullWidth />
            <Tooltip title="Only the positions you posted or manage (for your labs, consortia and organizations), including closed ones you can reopen">
              <FormControlLabel sx={{ whiteSpace: 'nowrap' }} label="Posted / managed by me"
                control={<Checkbox size="small" checked={Boolean(inputValues.mine)} onChange={(e) => onInputChange('mine', e.target.checked)} />} />
            </Tooltip>
          </Box>
        ) : activeTab === 2 ? (
          <Box display="flex" gap={2} flex={1}>
            <TextField
              label="Organization"
              value={inputValues.organization || ''}
              onChange={(e) => onInputChange('organization', e.target.value)}
              placeholder="Filter by university or institute..."
              size="small"
              fullWidth
            />
            <TextField
              label="Research topics"
              value={inputValues.keywords || ''}
              onChange={(e) => onInputChange('keywords', e.target.value)}
              placeholder="Filter by keywords..."
              size="small"
              fullWidth
            />
            <TextField
              label="Country"
              value={inputValues.country || ''}
              onChange={(e) => onInputChange('country', e.target.value)}
              placeholder="Filter by country..."
              size="small"
              fullWidth
            />
          </Box>
        ) : (
          <Box display="flex" gap={2} flex={1}>
            <TextField
              label="Organization Name"
              value={inputValues.organization || ''}
              onChange={(e) => onInputChange('organization', e.target.value)}
              placeholder="Filter by organization name..."
              size="small"
              fullWidth
            />
            <FormControl size="small" fullWidth>
              <InputLabel>Organization Type</InputLabel>
              <Select
                value={inputValues.orgType || ''}
                onChange={(e) => onInputChange('orgType', e.target.value)}
                label="Organization Type"
              >
                <MenuItem value="">All Types</MenuItem>
                <MenuItem value="academic">Academic</MenuItem>
                <MenuItem value="research_institution">Research Institution</MenuItem>
                <MenuItem value="hospital">Hospital</MenuItem>
                <MenuItem value="industry">Industry</MenuItem>
                <MenuItem value="government">Government</MenuItem>
                <MenuItem value="nonprofit">Non-Profit</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Country"
              value={inputValues.country || ''}
              onChange={(e) => onInputChange('country', e.target.value)}
              placeholder="Filter by country..."
              size="small"
              fullWidth
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default FilterPanel;
